<div class="global-message-container">
  <div class="global-message-item" *ngFor="let message of messages">
    <br-message
      [isClosable]="true"
      [autoRemove]="false"
      [message]="message.message + ' (' + message.remainingSec + 's)'"
      [state]="message.type"
      [showIcon]="true"
      (brDidClose)="onClose(message)"
    ></br-message>
  </div>
</div>
